import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { REDUCER_NAME } from './../../reducer';

const LIST_TAB = {
  mostRecent: 1,
  mostPopular: 2,
  contributors: 3,
};

class SwitchChildTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      listTab: [
        { value: `mostRecent` },
        { value: `mostPopular` },
        { value: `contributors` },
      ],
    };
  }

  onclickTab = value => {
    const { handleSwitchTab } = this.props;

    handleSwitchTab(LIST_TAB[value], 'currentChildTab');
  };

  render() {
    const { listTab } = this.state;
    const { currentChildTab } = this.props;

    return (
      <div className="d-flex">
        {listTab.map(({ value }, index) => (
          <a
            key={index}
            href="#"
            className={`btn btn-cus-nomal bg-b-color-3 ml-5 ${
              currentChildTab === LIST_TAB[value] ? 'active' : ''
            }`}
            onClick={() => this.onclickTab(value)}
          >
            {I18n.t(`newsAndAnalysis.exportViewTime.${value}`)}
          </a>
        ))}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  i18n: state.i18n,
  currentChildTab: state[REDUCER_NAME].currentChildTab,
});

export default connect(mapStateToProps)(SwitchChildTab);
